import React from 'react'
import {
  CardContent,
  TextField,
  Button,
  CardActions,
  Card,
  CardHeader,
} from '@material-ui/core'

const SqlMode = (props) => {
  const {
    sqlQuery,
    handleChangeSqlQuery,
    handleSaveSqlQuery,
    level,
    idTag,
    classes,
  } = props
  return (
    <Card>
      <CardHeader
        subheader="La consulta, debe retornar un conjunto de correos del la tabla de
              Sales Manago en base a las cédulas filtradas del DataLake,
              adicionalmente esta consulta debe filtrar la confianza con la que
              se va a ejecutar."
      />
      <CardContent>
        <br />
        <TextField
          id="outlined-multiline-static"
          label="SQL - CODE"
          multiline
          value={sqlQuery}
          minRows={20}
          onChange={handleChangeSqlQuery}
          variant="filled"
          fullWidth
        />
      </CardContent>
      <CardActions>
        <Button
          disabled={!(idTag?.estado === 'activo' || !level.level === 0)}
          onClick={handleSaveSqlQuery}
          variant="contained"
          className={classes.disabledButton}
          color="secondary"
        >
          GUARDAR CONSULTA
        </Button>
      </CardActions>
    </Card>
  )
}

export default SqlMode
